import { render, staticRenderFns } from "./clickCard.vue?vue&type=template&id=2d923598&scoped=true&"
import script from "./clickCard.vue?vue&type=script&lang=js&"
export * from "./clickCard.vue?vue&type=script&lang=js&"
import style0 from "./clickCard.vue?vue&type=style&index=0&id=2d923598&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d923598",
  null
  
)

export default component.exports